<template>
	<AppHeader hideBtn1 />

	<UiElement class="d-flex flex-column h-100 pb-0" :settings="appearance.body.settings">
		<div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
			<UiText :settings="heading1" class="text-center" :content="t('paymentComplete')" />

			<UiText :settings="heading2" class="text-center" :content="t('paymentCompleteTitle')" />

			<div class="w-100">
				<UiProgress :settings="general.elements.progress1.settings" :progress="100" animation="fade" />
			</div>
		</div>
	</UiElement>
</template>

<script setup>
	import { computed, onMounted, onUnmounted } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useRouter } from 'vue-router';

	import AppHeader from '@/components/AppHeader.vue';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiProgress from '@/components/UI/UiProgress.vue';

	import { useThemeStore } from '@/stores/useThemeStore';
	import { useInheritedElements } from '@/composables/useInheritedSettings';
	import { useTranslation } from '@/composables/useTranslation';
	import { useKioskRoute } from '@/composables/useKioskRoute';

	// Setup stores & routing
	const router = useRouter();
	const themeStore = useThemeStore();

	const { makePath } = useKioskRoute();
	const { theme } = storeToRefs(themeStore);
	const { t } = useTranslation();

	// Page Data
	const page = computed(() => theme.value.pages.paymentComplete ?? {});
	const appearance = computed(() => page.value.appearance ?? {});
	const elements = computed(() => page.value.elements ?? {});
	const general = computed(() => theme.value.general ?? {});

	// Inherited Elements
	const { get } = useInheritedElements(elements);
	const heading1 = get('heading1');
	const heading2 = get('heading2');

	// Lifecycle (redirect)
	let timeoutId;

	onMounted(() => {
		if (window.self === window.top) {
			timeoutId = setTimeout(() => {
				router.push(makePath('/end'));
			}, 12000);
		}
	});

	onUnmounted(() => {
		if (timeoutId) clearTimeout(timeoutId);
	});
</script>
